import React, { useEffect, useState } from "react";
import { fetchMeetupspagecity } from "../services/Meetupspagecity";
import { API_BASE } from "../api/apiConfig";

const Meetupspagecitydata = () => {
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadCities();
  }, []);

  const loadCities = async () => {
    try {
      const res = await fetchMeetupspagecity();
      console.log("🔥 API RESPONSE:", res);

      if (res?.status === true && Array.isArray(res.data)) {
        const flatCities = res.data.flatMap(item => item.city || []);
        console.log("✅ FLATTENED:", flatCities);
        setCities(flatCities);
      }
    } catch (err) {
      console.error("❌ API ERROR:", err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <p className="text-center py-10">Loading cities...</p>;
  }

  return (
    <section className="py-12 md:py-16 bg-slate-50">
      <div className="container mx-auto px-4 md:px-6">
        {/* Heading */}
        <div className="mb-8 text-center reveal-on-scroll revealed">
          <h2 className="text-2xl font-bold tracking-tight text-slate-800 md:text-3xl">
            Explore Meetups by <span className="text-gradient">City</span>
          </h2>
          <p className="mt-2 text-slate-600 max-w-2xl mx-auto">
            Discover travel meetups happening in these popular destinations across India
          </p>
        </div>

        {/* City Cards Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6 reveal-on-scroll revealed">

      {cities.map(city => (
          <div className="group relative rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-300 cursor-pointer">
            <div className="relative h-40 md:h-48">
              <img
                alt={city.city}
                loading="lazy"
                decoding="async"
                className="object-cover transition-transform duration-700 group-hover:scale-110"
                style={{
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: 0,
                  color: 'transparent'
                }}
                src={`${API_BASE}/${city.cover_image}`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/50 to-black/20 transition-opacity duration-300 group-hover:opacity-70"></div>
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-4 text-white">
              <h3 className="text-lg font-bold mb-1">{city.city}</h3>
              <p className="text-sm text-white/80 mb-2">{city.title}</p>
              <div className="flex items-center gap-2">
                <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-white/20 backdrop-blur-sm border-none text-white">
                  {city.meetup_count} meetups
                </div>
              </div>
            </div>
          </div>
        ))}

        </div>
      </div>
    </section>
  );
};

export default Meetupspagecitydata;
